import React from 'react';
import CodeHeader from './../styled/CodeHeader';
import CodeBacker from './../styled/CodeBacker';
import StyledIframe from './../styled/Iframe';

import reset from './styleReset';

class Iframe extends React.Component {
  constructor(props) {
    super(props);
    this.iframe = React.createRef();
  }

  componentDidMount() {
    this.updateIframe();
  }

  componentDidUpdate() {
    this.updateIframe();
  }

  updateIframe() {
    const html = `
    <head>
      <style>${reset}</style>
    </head>
    <body>
      <div>${this.props.code}</div>
    </body>`;

    const iframe = this.iframe.current;
    if (!iframe) return;

    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(html);
    iframe.contentWindow.document.close();

    const height = iframe.contentWindow.document.body.offsetHeight;
    iframe.style.height = `${height}px`;
  }

  render() {
    return (
      <CodeBacker {...this.props.attributes}>
        <CodeHeader textAlign='left'>
          <i className='fas fa-code' /> Code: iframe
        </CodeHeader>
        <StyledIframe
          innerRef={this.iframe}
        />
        <CodeHeader textAlign='right'>
          <i className='fas fa-code' />
        </CodeHeader>
      </CodeBacker>
    );
  }
}

export default Iframe;
